'use client';

import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

export const HeaderAnchorContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

export const useHeaderAnchor = (): RefObject<HTMLElement | null> => {
  const anchorRef = useContext(HeaderAnchorContext);

  if (!anchorRef) {
    throw new Error(
      'useHeaderAnchor must be used within HeaderAnchorContext.Provider'
    );
  }

  return anchorRef;
};
